import ElyRichardTEmbed from "../images/ElyRichardTEmbed";
import Ely from "../Thumbs/Ely60.jpg";

const ElyRichardT = {
    objectName: 'ElyRichardT',
    firstName: 'Richard T',
    lastName: 'Ely',
    dates: '1854–1943',
    id: 'RTE18541943',
    image: ElyRichardTEmbed,
    thumbImg: Ely,
    quotes: [
    {
        tabHeading: 'Govt Makes People Equal - Richard T Ely',
        metaDescription: `Richard T Ely quote stating people are not born free or equal, that it is govt's role to make them so.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Govt Makes People Free and Equal',
        id: 'PRRweNeedGodSpch',
        date: '',
        headTitle: ``,
        headDescription: ``,
        content: [
            {normal: `Earlier Americans, were wrongly inclined to regard men as substantially equal, and to suppose that all could live 
        under the same economic and political institutions.  It now becomes plain, that this is a theory that works disaster, and is indeed 
        cruel to those who are in the lower stages of development, resulting in their exploitation and degradation.  Human beings are by nature 
        unfree and unequal. It becomes the main task of govt to make them equal.`},
            {normal: `There is no limit to the right of the state, save its ability to do good`},
        ],
        considerations: [
            {
                name: '',
                title: 'Ronald Reagan',
                date: '',
                content: [`If we ever forget that we are one nation under God, then we will be a nation gone under.`]
            },
            {
              name: '',
              title: 'Thomas Jefferson',
              date: '',
              content: [`God who gave us life gave us liberty. And can the liberties of a nation be thought secure when we have removed their only firm basis, a 
            conviction in the minds of the people that these liberties are of the Gift of God? That they are not to be violated but with His wrath? Indeed, I 
            tremble for my country when I reflect that God is just; that His justice cannot sleep forever; That a revolution of the wheel of fortune, a change of 
            situation, is among possible events; that it may become probable by Supernatural influence! The Almighty has no attribute which can take side with us 
            in that event.`]
          }
        ]
    }    
]};

export default ElyRichardT;